import styled from 'styled-components';

type S = { $scrolled?: boolean };

/* Плаваючий острівець: fixed поверх контенту, фон ПРОЗОРИЙ — контент видно за ним */
export const StyledHeader = styled.header<S>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  justify-content: center;
  padding: ${p => (p.$scrolled ? '10px 16px' : '16px 16px')};
  background: transparent;
  pointer-events: none;
  transition: padding 400ms cubic-bezier(0.4, 0, 0.2, 1);

  @media screen and (max-width: 767px) {
    padding: 10px 16px;
  }
`;

export const HeaderInner = styled.div<S>`
  pointer-events: auto;
  width: 100%;
  max-width: ${p => (p.$scrolled ? '784px' : '1200px')};
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 12px;
  padding: ${p => (p.$scrolled ? '7px 12px 7px 20px' : '9px 14px 9px 24px')};
  background: ${p => p.theme.colors.greyBackgroundPaper};
  border: none;
  box-shadow: 0 8px 30px rgba(23, 26, 29, 0.1), 0 2px 8px rgba(23, 26, 29, 0.06);
  border-radius: ${p => p.theme.radii.pill};
  transition: max-width 400ms cubic-bezier(0.4, 0, 0.2, 1),
    padding 400ms cubic-bezier(0.4, 0, 0.2, 1);

  @media screen and (max-width: 767px) {
    display: flex;
    max-width: 360px;
    padding: 6px 10px;
    background: ${p => (p.$scrolled ? p.theme.colors.greyBackgroundPaper : 'transparent')};
    box-shadow: ${p =>
      p.$scrolled ? '0 8px 30px rgba(23, 26, 29, 0.1), 0 2px 8px rgba(23, 26, 29, 0.06)' : 'none'};
    transition: max-width 320ms cubic-bezier(0.4, 0, 0.2, 1),
      padding 320ms cubic-bezier(0.4, 0, 0.2, 1),
      background 320ms ease, box-shadow 320ms ease;
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    max-width: ${p => (p.$scrolled ? '480px' : '700px')};
    padding: ${p => (p.$scrolled ? '6px 10px 6px 16px' : '8px 12px 8px 20px')};
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  justify-self: start;
`;

export const HeaderCenter = styled.div`
  display: flex;
  align-items: center;
  justify-self: center;
  padding: 0 22px;
  border-left: 1.5px dotted ${p => p.theme.colors.textPrimary};
  border-right: 1.5px dotted ${p => p.theme.colors.textPrimary};

  @media screen and (max-width: 1279px) {
    border: none;
    padding: 0;
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    padding: 0 14px;
    border-left: 1.5px dotted ${p => p.theme.colors.textPrimary};
    border-right: 1.5px dotted ${p => p.theme.colors.textPrimary};
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-self: end;
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${p => p.theme.radii.pill};
  background: transparent;
  color: ${p => p.theme.colors.textPrimary};
  transition: ${p => p.theme.transition.main};

  &:hover {
    background: ${p => p.theme.colors.background};
    color: ${p => p.theme.colors.secondary};
  }
`;

export const DesktopWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;
